export default async function transformCsv(res) {
  const text = await res.text();
  const contentDisposition = res.headers.get('content-disposition');
  let filename;
  if (contentDisposition) {
    filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
  } else {
    filename = 'default.csv';
  }

  const blob = new Blob([text], {
    encoding: 'UTF-8',
    type: 'text/csv;charset=UTF-8',
  });

  const file = new File([blob], filename, { type: 'text/csv;charset=UTF-8' });
  return file;
}
